import { render, staticRenderFns } from "./SafeDigGrants.vue?vue&type=template&id=d063ead4&scoped=true"
import script from "./SafeDigGrants.vue?vue&type=script&lang=js"
export * from "./SafeDigGrants.vue?vue&type=script&lang=js"
import style0 from "./SafeDigGrants.vue?vue&type=style&index=0&id=d063ead4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d063ead4",
  null
  
)

export default component.exports